<template>
  <main class="wrapper">
    <section class="container" id="control">
      <div style="text-align: center; font-size: 100px">🐱</div>
      <div style="text-align: center;">Ты забрел куда то не туда, котик</div>
      <div style="text-align: center;"><a href="/">Домой</a></div>
    </section>
  </main>
</template>
<script>
import 'swagger-ui/dist/swagger-ui.css';

export default {}
</script>